import blogList from '../../../../assets/blog/blog-list.json';

export const Schema = {
  "@context": "https://schema.org",
  "@type": "Article",
  "headline": blogList.posts['cactus-to-clouds']['title'],
  "image": "https://kopatours.com/assets/img/" + blogList.posts['cactus-to-clouds']['photoRoute'],
  "author": "David Straily",
  "editor": "David Straily",
  "genre": "Fitness & Hiking",
  "keywords": "Training Hiking Trail Kilimanjaro Fitness ",
  "publisher": {
    "@type": "Organization",
    "name": "Kopa Tours",
    "logo": {
      "@type": "ImageObject",
      "url": "https://kopatours.com/assets/img/kopa-branding/1x/kopalogofinal.png"
    }
  },
  "url": "https://kopatours.com/blog/post/" + blogList.posts['cactus-to-clouds']['linkToPost'],
  "mainEntityOfPage": {
    "@type": "WebPage",
    "@id": "https://kopatours.com/blog/post/" + blogList.posts['cactus-to-clouds']['linkToPost'],
  },
  "datePublished": blogList.posts['cactus-to-clouds']['postDate'],
  "dateCreated": blogList.posts['cactus-to-clouds']['postDate'],
  "dateModified": "2020-11-12",
  "description": blogList.posts['cactus-to-clouds']['description'],
};


